import React, { useState, useEffect } from 'react';
import { FaArrowUp, FaArrowDown, FaPlus } from 'react-icons/fa';
import balanceService from '../../../utils/balanceService';
// Logo will be loaded from public folder
import './BalanceCard.css';

const BalanceCard = ({ user, onSendMoney, onRequestMoney }) => {
  const [currentBalance, setCurrentBalance] = useState(user?.balance || 0);

  // Update balance from persistent storage
  useEffect(() => {
    if (user?.id) {
      const updatedBalance = balanceService.getUserBalance(user.id);
      setCurrentBalance(updatedBalance);
    }
  }, [user?.id]);

  const formatBalance = (balance) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(balance);
  };

  return (
    <div className="balance-card">
      <div className="card-logo">
        <div className="wave-container">
          <svg className="wave-svg" viewBox="0 0 500 150" preserveAspectRatio="none">
            <path d="M0,100 C100,40 150,40 250,100 C350,40 400,40 500,100 L500,0 L0,0 Z" 
                  style={{stroke: 'none', fill: 'rgba(0, 136, 251, 0.12)'}} />
          </svg>
        </div>
        <div className="venmo-logo">
          <img src="/images/solid-color-logo.png" alt="Venmo Logo" />
        </div>
      </div>
      
      <div className="balance-header">
        <div className="user-info">
          <img 
            src={user?.profile_picture || 'https://i.pravatar.cc/60?img=1'} 
            alt={user?.name || 'User'}
            className="user-avatar"
          />
          <div className="user-details">
            <h2 className="user-name">{user?.name || 'Demo User'}</h2>
            <p className="user-username">@{user?.username || 'demo_user'}</p>
          </div>
        </div>
        
        <div className="balance-display">
          <div className="balance-label">VENMO BALANCE</div>
          <div className="balance-amount">
            {formatBalance(currentBalance)}
          </div>
        </div>
      </div>
      
      <div className="balance-actions">
        <button className="action-btn btn-primary" onClick={onSendMoney} aria-label="Go to Pay">
          <FaArrowUp />
          <span>Pay</span>
        </button>
        
        <button className="action-btn btn-outline" onClick={onRequestMoney} aria-label="Go to Request">
          <FaArrowDown />
          <span>Request</span>
        </button>
        
        <button className="action-btn btn-outline" onClick={() => alert("Feature not implemented yet")} aria-label="Add Money">
          <FaPlus />
          <span>Add Money</span>
        </button>
      </div>
    </div>
  );
};

export default BalanceCard;